import { useTranslation } from "react-i18next";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import LastServiceCard from "./LastServiceCard";

const LastServicesList = ({ services, deviceUuid }) => {
  const { t } = useTranslation();

  if (!deviceUuid) return null;

  if (services.length === 0) {
    return (
      <div className="empty-state">
        Brak wcześniejszych serwisów dla tego urządzenia
      </div>
    );
  }
  const goToDevice = (uuid) => {
    if (uuid) {
      let origin = window.location.origin;
      origin += `/#/dashboard/device/${uuid}`;
      window.open(origin, "_blank", "noreferrer");
    }
  };

  return (
    <>
      <div style={{ marginBottom: "30px" }}>
        <BMXSeparator
          title={t("global:service.lastServices")}
          children={
            <span
              style={{ cursor: "pointer" }}
              onClick={() => goToDevice(deviceUuid)}
            >
              {t("global:service.showMoreAboutDevice")}
            </span>
          }
        />
      </div>

      {services.map((service, index) => (
        <LastServiceCard
          key={service.uuid}
          service={service}
          isFirst={index === 0}
        />
      ))}
    </>
  );
};

export default LastServicesList;
